/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_EmptyInputs */

const cs_clients_empty = /** @type {(inputs: Clients_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádní klienti.`)
};

const en_clients_empty = /** @type {(inputs: Clients_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No clients yet.`)
};

/**
* | output |
* | --- |
* | "No clients yet." |
*
* @param {Clients_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_empty = /** @type {((inputs?: Clients_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_empty(inputs)
	return cs_clients_empty(inputs)
});